module.exports = __webpack_public_path__ + "img/foot-wx.d16a33cf.png";